import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { initLenis, scrollTop } from "./lib/smooth";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Floating } from "./components/Floating";
import AuthCallback from "./components/AuthCallback";
import Home from "./pages/Home";
import Azienda from "./pages/Azienda";
import Servizi from "./pages/Servizi";
import Lavori from "./pages/Lavori";
import Privati from "./pages/Privati";
import Aziende from "./pages/Aziende";
import Contatti from "./pages/Contatti";
import Privacy from "./pages/Privacy";
import Cookie from "./pages/Cookie";
import Login from "./pages/Login";
import Admin from "./pages/Admin";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) scrollTop(true);
  }, [pathname, hash]);
  return null;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollManager />
      <div className="noise-overlay" aria-hidden="true" />
      <Header />
      <main className="pb-[68px] md:pb-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/azienda" element={<Azienda />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/lavori" element={<Lavori />} />
          <Route path="/privati" element={<Privati />} />
          <Route path="/aziende" element={<Aziende />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookie" element={<Cookie />} />
          <Route path="/accedi" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <Floating />
    </>
  );
}

function App() {
  useEffect(() => initLenis(), []);
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppRouter />
          <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#1C2027", border: "1px solid #2A303A", color: "#F3F4F6", borderRadius: 0 } }} />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
